module.exports = __webpack_public_path__ + "img/route-outline-black.61ed212c.svg";